import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EMICalculator from './EMICalculator';
import TermsOfUse from './TermsOfUse';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<EMICalculator />} />
        <Route path="/terms" element={<TermsOfUse />} />
      </Routes>
    </Router>
  );
}

export default App;